// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-bar-button[data-v-8d9cf4be] {\n  /* padding: 7px 16px; */\n  border-radius: 10px;\n}\n.bg-yellow-100[data-v-8d9cf4be] {\n  background-color: #ffda69;\n}\n.left-side-bar[data-v-8d9cf4be] {\n@media (min-width: 640px) {\n    max-width: 305px;\n}\n}\n.left-side-bar-content[data-v-8d9cf4be] {\n  font-family: \"Outfit\";\n  border-radius: 20px;\n}\n@media (min-width: 641px) {\n.yellowBG[data-v-8d9cf4be]{\n    background-color: #ffda69;\n}\n}\n", ""]);
// Exports
module.exports = exports;
